import I18n from "i18n-js";
import { makeImmutable, toPairs } from "../../core";
import { CheckboxFieldControler, ErrorBox, TextFieldControler, } from "../../form";
import { InvoiceRequest, VatId } from "../../ordering";
export class InvoiceFormControler {
    constructor(params) {
        var _a, _b;
        this.orderReceiver = params.orderReceiver;
        this.vatId = new TextFieldControler({
            initialValue: (_b = (_a = this.orderReceiver.invoiceRequest) === null || _a === void 0 ? void 0 : _a.vatId.toString()) !== null && _b !== void 0 ? _b : "",
            update: (value) => {
                this.orderReceiver.invoiceRequest = new InvoiceRequest({
                    vatId: new VatId(value),
                });
            },
            errorBox: new ErrorBox({
                domainObjects: [this.orderReceiver],
                errorMessages: {
                    VatIdMissing: I18n.t("_common.form.errors.required"),
                    VatIdInvalid: I18n.t("activerecord.errors.models.order.attributes.vat_id.invalid"),
                },
            }),
        });
        this.isInvoiceNeeded = new CheckboxFieldControler({
            initialValue: this.orderReceiver.invoiceRequest !== null,
            update: (value) => {
                if (value) {
                    this.vatId.onChange("");
                }
                else {
                    this.orderReceiver.invoiceRequest = null;
                }
            },
        });
        makeImmutable(this);
    }
    get fields() {
        return {
            isInvoiceNeeded: this.isInvoiceNeeded,
            vatId: this.vatId,
        };
    }
    touch() {
        toPairs(this.fields).forEach(([, field]) => field.onBlur());
    }
}
